import styled, { css } from 'styled-components'
import { theme } from '@notino/react-styleguide'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { BREAKPOINTS, CONTAINER_X_PADDING } from '../../styles/constants'
import { ReservationCardSliderMobileBreakpoint } from './types'

const GRID_GAP_MOBILE = 20 // in px
const VISIBLE_PART_OF_NEXT_RESERVATION_CARD = 20 // in px

export const ReservationsSliderContainer = styled.div`
	margin-left: -${CONTAINER_X_PADDING}px;
	margin-right: -${CONTAINER_X_PADDING}px;
`

export const MobileSlider = styled.div<{ $breakpoint: ReservationCardSliderMobileBreakpoint; $isLazyLoadingData: boolean }>`
	${({ $breakpoint }) => css`
		display: flex;
		overflow-y: auto;
		scroll-snap-type: x mandatory;
		scroll-behavior: smooth;
		gap: ${GRID_GAP_MOBILE}px;
		padding-left: ${CONTAINER_X_PADDING}px;
		padding-right: ${CONTAINER_X_PADDING}px;

		@media (min-width: ${BREAKPOINTS[$breakpoint]}) {
			display: none;
		}
	`}

	${({ $isLazyLoadingData }) =>
		$isLazyLoadingData &&
		css`
			pointer-events: none;
			overflow: hidden;
		`}
`

export const DesktopSlider = styled.div<{
	$breakpoint: ReservationCardSliderMobileBreakpoint
	$showPrevArrow: boolean
	$showNextArrow: boolean
	$isLazyLoadingData: boolean
}>`
	${({ $breakpoint, $showPrevArrow, $showNextArrow, $isLazyLoadingData }) => css`
		display: none;
		padding-left: ${CONTAINER_X_PADDING}px;
		padding-right: ${CONTAINER_X_PADDING}px;

		@media (min-width: ${BREAKPOINTS[$breakpoint]}) {
			display: block;

			.slick-track {
				display: flex;
				margin-left: initial;
				margin-right: initial;

				.slick-slide {
					height: auto;
					display: flex;

					> div {
						width: 100%;
						display: flex;
					}
				}
			}

			.slick-arrow {
				color: ${theme.color.icon.primary};
				z-index: 10;

				&.slick-prev {
					left: -${CONTAINER_X_PADDING / 2}px;
				}

				&.slick-next {
					right: -${CONTAINER_X_PADDING / 2}px;
				}
			}

			${
				!$showPrevArrow &&
				css`
					.slick-arrow.slick-prev {
						display: none !important;
					}
				`
			}

			${
				!$showNextArrow &&
				css`
					.slick-arrow.slick-next {
						display: none !important;
					}
				`
			}

			${
				$isLazyLoadingData &&
				css`
					.slick-track {
						pointer-events: none;
					}

					.slick-arrow {
						pointer-events: none;
					}
				`
			}
		}
	`}
`

export const SlideWrapper = styled.div<{
	$breakpoint: ReservationCardSliderMobileBreakpoint
	$isFirstItem: boolean
	$isLastItem: boolean
	$slidesCount: number
}>`
	${({ $breakpoint, $isFirstItem, $isLastItem, $slidesCount }) => css`
		flex-shrink: 0;
		scroll-snap-align: center;
		scroll-snap-stop: always;
		width: ${$slidesCount > 1 ? `calc(100% - ${GRID_GAP_MOBILE}px - ${VISIBLE_PART_OF_NEXT_RESERVATION_CARD}px)` : '100%'};

		@media (min-width: ${BREAKPOINTS.sm}) {
			width: ${
				$slidesCount > 2
					? `calc(100% / 2 - ${GRID_GAP_MOBILE}px - ${VISIBLE_PART_OF_NEXT_RESERVATION_CARD}px)`
					: `calc(100% / 2 - ${GRID_GAP_MOBILE / 2}px)`
			};
			scroll-snap-align: none;
			scroll-snap-stop: normal;
		}

		@media (min-width: ${BREAKPOINTS[$breakpoint]}) {
			${() => {
				if ($isFirstItem && !$isLastItem) {
					return css`
						padding-right: 20px;
					`
				}

				if (!$isFirstItem && $isLastItem) {
					return css`
						padding-left: 20px;
					`
				}

				if (!$isFirstItem && !$isLastItem) {
					return css`
						padding: 0 20px;
					`
				}

				return css`
					padding: 0;
				`
			}};
		}
	`}
`
